export const tokensHints = {
  token: 'A token is implemented via a smart contract and can represent virtually anything on æternity. The AEX-9 fungible token standard allows developers to build token applications that are interoperable with other products and services. A fungible token is divisible and interchangeable.',
  tokenSymbol: 'Non-unique symbol of the token.',
  tokenName: 'Full name of the token.',
  smartContractId: 'Identifier of the smart contract that implements the AEX-9 fungible token standard.',
  price: 'Price of the token in AE and USD.',
  value: 'The total value of the tokens in USD. Prices of the tokens are sourced from Superhero DEX.',
  totalSupply: 'Amount of tokens in circulation.',
  decimals: 'The decimal granularity of each token.',
  extensions: 'Extensions that are implemented for this token according to the creator of the smart contract.',
  apiLinks: 'Links to sources of the token data.',
  account: 'Account of the token holder.',
  holders: 'Amount of holders of the token.',
  amount: 'Amount of the tokens held by its owner.',
  percentage: 'Percentage of the token supply held by the account.',
  hash: 'Transaction hash of the event.',
  eventName: 'Name of the event. The "N/A" value means that it\'s not a part of the standard AEX-9 interface.',
  date: 'Keyblock height and the estimated date and time of the transaction.',
}
